// extracted by mini-css-extract-plugin
export default {"splashPage":"PlotBar_splashPage__LP8mb"};